import {useState} from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export function Contact (props)
{

    const [toSend, setToSend] = useState({
      message: '',
    });

    const [alertMessage,       setAlertMessage]        = useState("");
    const [alertOpen,          setAlertOpen]           = useState(false);
    const [severity,           setSeverity]           = useState("success");

    // Open WhatsApp with only the message text from the form
    const  sendEmail = (e) => {
      e.preventDefault();
      const text = toSend.message || "";
      const url = "https://wa.me/972522541131?text=" + encodeURIComponent(text);
      window.open(url, '_blank');
      setAlertMessage("נפתח חלון WhatsApp להכנסת ההודעה ושליחתה");
      setSeverity("success");
      setAlertOpen(true);
      setToSend({message: ''});
    }

    const handleAlertClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setAlertOpen(false);
    };
  
    

    const  messageChange = (e) => {
      setToSend({ ...toSend, [e.target.name]: e.target.value });
    }


    return( 

      <>
        <Snackbar 
          open={alertOpen} 
          autoHideDuration={6000} 
          onClose={handleAlertClose}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
          >
            <Alert 
              dir = "rtl" 
              sx={{textAlign: "right", width: '100%'}} 
              severity= {severity} >
                  {alertMessage}
            </Alert>
        </Snackbar>


        <section id = "contact" className = "contact"> 
        <div className = "container">
          <div className = "section-title">
            <h2> צור קשר </h2> 
            <p> אשמח לפגוש אתכם בקליניקה הפרטית שלי בתל מונד או במרפאת מכבי שירותי בריאות בסניף תל מונד או כפר סבא הירוקה.אנא מלאו את הטופס ואחזור אליכם בהקדם </p> 
          </div>

          <div className = "row" data-aos = "fade-in">
            <div className = "col-lg-5 d-flex align-items-stretch">
              <div className = "info">
                
              <div className="address">
                <a href="https://ul.waze.com/ul?place=ChIJcVpk86E_HRURz8aYsnDCTXA&ll=32.25318360%2C34.92231170&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
                        target="_blank" rel="noreferrer"><i className="bi bi-geo-alt"></i></a>
                <h4>כתובת:</h4>
                <p>האהבה 7, תל מונד</p>
              </div>

                <div className = "email">
                  <a href = "mailto:roni@hollander.fm" target = "_blank" rel="noreferrer"> <i className = "bi bi-envelope"> </i></a>
                  <h4> אימייל: </h4> 
                  <p> roni @hollander.fm </p> 
                </div> 

                <div className = "phone">
                  <a href = "tel:+972522541131" target = "_blank" rel="noreferrer"> <i className = "bi bi-phone"> </i></a>
                  <h4> טלפון: </h4> 
                  <p> 052-2541131 </p> 
                </div> 

                <div>
                  <iframe 
                    width = "100%" 
                    height = "290" 
                    id = "gmap_canvas" 
                    src = "https://maps.google.com/maps?q=Roni%20Hollander&t=&z=14&ie=UTF8&iwloc=&output=embed"
                    title = "Map"
                    frameBorder = "0"
                    scrolling = "no"
                    marginHeight = "0"
                    marginWidth = "0"> 
                  </iframe> 
                </div> 
              </div> 
            </div>

            <div className = "send-message col-lg-7 mt-5 mt-lg-0  align-items-stretch">

              <form className = "php-email-form" onSubmit={sendEmail} >
                <div className = "form-group">
                  <label htmlFor = "name"> הודעה </label> 
                    <textarea 
                        className = "form-control" 
                        name = "message" 
                        rows = "5" 
                        value={toSend.message}
                        onChange={messageChange}                        
                        required> 
                    </textarea> 
                </div>

                <div className = "text-center">
                  <button type = "submit" className="btn-whatsapp" title="שלח ב-וואטסאפ" aria-label="שלח בוואטסאפ" style={{backgroundColor: '#25D366', color: '#fff', border: '0', boxShadow: '0 6px 20px rgba(0,0,0,0.20)', borderRadius: '6px'}}> <i className = "bi bi-whatsapp"> </i>&nbsp;&nbsp;שלח ב-וואטסאפ</button>
                </div>
              </form>

            </div> 
          </div> 
        </div> 
      </section>
    </>

    )
}

export default Contact
